module.exports = __webpack_public_path__ + "img/gotoTop@2x.396f4e9a.png";